
import { defineComponent, SetupContext, PropType } from "vue";
import NativeClient from "@/client/native-client";
import { IngredientCategoryData } from "@/types/pantry";
import PantryIngredientFoodView from "./PantryIngredientFoodView.vue";
export default defineComponent({
  name: "PantryIngredientFoodListView",
  components: {
    PantryIngredientFoodView
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    foodList: {
      type: Array as PropType<IngredientCategoryData[]>,
      default: () => [],
      required: true
    },
    selectName: {
      type: String,
      default: "",
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const onSelectIngredient = (
      categoryName: string,
      id: number,
      name: string,
      isSelect: boolean
    ) => {
      NativeClient.sendDebugLog(
        "PantryIngredientFoodListView onSelectIngredient id=" +
          categoryName +
          "ingredientId = " +
          id +
          ", name = " +
          name +
          ", isSelect = " +
          isSelect
      );
      context.emit("on-select", categoryName, id, name, isSelect);
    };
    return {
      onSelectIngredient
    };
  }
});
